import * as React from 'react';
import { cn } from '../../utils/cn';

/**
 * Error icon for displaying error states
 * Usage: <ErrorIcon className="h-12 w-12" />
 */
/** @deprecated Use icons from icons-v2-generated instead. */
export function ErrorIcon({ className, fill = '#FF6B6B', ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('inline-block', className)}
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );
}